import { FlatRatesTypes } from 'swag-common/constants/shipping.constants';
const checkIsReceiverFlatRateSelected = receiver => receiver.shipment && [FlatRatesTypes.Domestic, FlatRatesTypes.International].includes(receiver.shipment.selectedDeliveryServiceCode);
export default checkIsReceiverFlatRateSelected;